module.exports = __webpack_public_path__ + "assets/d61e138b28775293e27476232a6cd6b5.png";